function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint complexity: 0 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SVGIcon } from '@homeaway/react-svg';
import { CHEVRON_DOWN__16 } from '@homeaway/svg-defs';
import classNames from 'classnames';
import "./NavigationBase.css";
/**
 * Navigation Base
 *
 */

var NavigationBase = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NavigationBase, _Component);

  /* istanbul ignore next */
  function NavigationBase(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.updateHighlight = function () {
      _this.setState({
        isTransitioning: true
      });

      _this.transitionTimeout = setTimeout(function () {
        _this.setState({
          isTransitioning: false
        });
      }, 300);
    };

    _this.handleClick = function (isNode, e) {
      var index;

      if (e.currentTarget.dataset.index) {
        index = Number(e.currentTarget.dataset.index);
      } else {
        index = e.currentTarget.selectedIndex;
      } // Assume the node being used is a <Link> with an href to route to.


      if (!isNode) {
        e.preventDefault();
      }

      _this.props.onLinkClick(e, index);
    };

    _this.handleChange = function (e) {
      _this.handleClick(false, e);
    };

    _this.renderLink = function (link, i) {
      var _extends2;

      var _this$props = _this.props,
          activeIndex = _this$props.activeIndex,
          srHidden = _this$props.srHidden;
      var isActive = Number(activeIndex) === i;
      var aClasses = classNames({
        Navigation__a: true,
        'Navigation__a--active': isActive,
        'Navigation__a--disabled': link.disabled
      }, link.className);

      var aProps = _extends((_extends2 = {}, _extends2['data-index'] = i, _extends2.className = aClasses, _extends2), !link.node && !link.disabled && {
        href: link.href
      }, !link.disabled && {
        onClick: _this.handleClick.bind(_assertThisInitialized(_this), !!link.node)
      }, srHidden && {
        tabIndex: -1,
        'aria-hidden': true
      });
      /* For the most part, this is assuming link.node is a Link component from react-router-dom.
       * Other use cases' success may vary.  (Note that we don't pass href in link.node as Link uses `to` prop).
       * Need to wrap the cloned link.node in a <span> so the ref is a DOM element and its
       * dimensions can later be calculated.
       */


      if (link.node) {
        return /*#__PURE__*/React.createElement("span", {
          ref: function ref(element) {
            link.ref = element;
          }
        }, /*#__PURE__*/React.cloneElement(link.node, _extends({}, aProps)));
      }

      return /*#__PURE__*/React.createElement("a", _extends({}, aProps, {
        ref: function ref(element) {
          link.ref = element;
        }
      }), link.label);
    };

    _this.state = {
      isTransitioning: false
    };
    return _this;
  }

  var _proto = NavigationBase.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // Silly check for Enzyme 3 shallow rendering now having refs
    if (this.ul) {
      this.updateHighlight();
    }
    /* istanbul ignore next */


    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.updateHighlight);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.activeIndex !== prevProps.activeIndex || this.props.links !== prevProps.links) {
      // When the activeIndex or the links are updated, transition
      // the highlight to the new item.
      this.updateHighlight();
    }
  }
  /* istanbul ignore next */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateHighlight);
    }

    if (this.transitionTimeout) {
      clearTimeout(this.transitionTimeout);
      this.transitionTimeout = null;
    }
  };

  /* eslint-disable complexity */
  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        links = _this$props2.links,
        className = _this$props2.className,
        activeIndex = _this$props2.activeIndex,
        leftAlign = _this$props2.leftAlign,
        inverse = _this$props2.inverse,
        noMobileSelect = _this$props2.noMobileSelect,
        vertical = _this$props2.vertical,
        withBorder = _this$props2.withBorder;

    if (!(links || []).length) {
      return null;
    }

    var isTransitioning = this.state.isTransitioning;
    var navClasses = classNames({
      Navigation: !inverse,
      'Navigation--inverse': inverse,
      'Navigation--left-align': leftAlign,
      'Navigation--mobile-tabs': noMobileSelect && !vertical,
      'Navigation--divider': withBorder
    }, className);
    var highlightStyle;

    if (this.ul && this.ul.childNodes && this.ul.childNodes.length > 0 && this.ul.childNodes[activeIndex] && this.ul.childNodes[activeIndex].childNodes && this.ul.childNodes[activeIndex].childNodes.length > 0) {
      var activeBarWidth = vertical ? 24 : this.ul.childNodes[activeIndex].offsetWidth;
      var activeBarOffset = vertical ? this.ul.childNodes[activeIndex].offsetTop + this.ul.childNodes[activeIndex].childNodes[0].offsetTop : this.ul.childNodes[activeIndex].offsetLeft;
      var transformString = "translate" + (vertical ? 'Y' : 'X') + "(" + activeBarOffset + "px) scale" + (vertical ? 'X' : 'Y') + "(" + (isTransitioning ? '2' : '1') + ")";
      highlightStyle = {
        transform: transformString,
        width: !vertical ? activeBarWidth : '',
        height: vertical ? 24 : ''
      };
    }

    var iconVariant = inverse ? 'text-white' : '';
    return /*#__PURE__*/React.createElement("nav", {
      className: navClasses
    }, /*#__PURE__*/React.createElement("ul", {
      className: "Navigation__ul",
      ref:
      /* istanbul ignore next */
      function ref(ul) {
        _this2.ul = ul;
      }
    }, links.map(function (link, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: "nav-item-" + i,
        className: "Navigation__li"
      }, _this2.renderLink(link, i));
    }), /*#__PURE__*/React.createElement("li", {
      "aria-hidden": "true",
      style: highlightStyle,
      className: "Navigation__li--highlight"
    })), !noMobileSelect && /*#__PURE__*/React.createElement("div", {
      className: "Navigation__select-wrapper visible-xs"
    }, /*#__PURE__*/React.createElement("select", {
      value: links[activeIndex].href,
      className: "Navigation__select",
      onChange: this.handleChange
    }, links.map(function (link, i) {
      return /*#__PURE__*/React.createElement("option", {
        disabled: link.disabled,
        value: link.href,
        key: "nav-option-" + i
      }, link.label);
    })), /*#__PURE__*/React.createElement(SVGIcon, {
      className: "Navigation__select-chevron " + iconVariant,
      markup: CHEVRON_DOWN__16
    })));
  }
  /* eslint-enable */
  ;

  return NavigationBase;
}(Component);

NavigationBase.propTypes = {
  /** Array of link objects. They could include the properties: label, href, disabled. Use the node property to pass in a Link component from react-router. */
  links: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    ref: PropTypes.object
  })), PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    label: PropTypes.node,
    node: PropTypes.node.isRequired,
    ref: PropTypes.object
  }))]).isRequired,

  /** Inverse styling */
  inverse: PropTypes.bool,

  /**
   * Event handler trigger when a user clicks a link, will receive both
   * the event and active index number as params. Update activeIndex in
   * this handler to the specified index to transition the navigation.
   */
  onLinkClick: PropTypes.func,

  /** The index number of active nav item */
  activeIndex: PropTypes.number,

  /** Force tabs to be used in mobile, instead of a dropdown select. Defaults true on VerticalNavigaiton */
  noMobileSelect: PropTypes.bool,

  /** Make invisible to screen readers and remove it from tab navigation */
  srHidden: PropTypes.bool
};
NavigationBase.defaultProps = {
  activeIndex: 0,
  onLinkClick: function onLinkClick() {},
  noMobileSelect: false
};
export default NavigationBase;
//# sourceMappingURL=NavigationBase.js.map